






import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class DatePicker extends Vue {
  @Prop({ default: "" }) value?: string;
  @Prop({ default: "" }) id?: string;
  @Prop({ default: "" }) dataCy?: string;
  @Prop({ default: false }) isRange!: boolean;

  onDatePickerChange(value: string[]) {
    this.$emit("input", value);
  }

  get datePickerProps() {
    const props: Record<string, any> = {};
    if (this.isRange) {
      props.range = true;
    }
    return props;
  }

  MakeButtonDisabled(button: HTMLElement) {
    if (button.classList.contains("v-btn--disabled")) {
      button.classList.remove("v-btn--disabled");
      button.classList.add("greyedOut");
      button.removeAttribute("disabled");
    }
  }

  ConvertDatesOnPopup(customDatePicker: Element) {
    const disabledButtons = customDatePicker.getElementsByClassName("v-btn--flat");
    if (disabledButtons != null) {
      for (let i = 0; i < disabledButtons.length; i++) {
        const button = disabledButtons[i] as HTMLElement;
        this.MakeButtonDisabled(button);
      }
    }
  }

  mounted() {
    if (this.id) {
      const customDatePicker = document.getElementById(this.id) as HTMLElement;

      if (customDatePicker) {
        //Initially when datepicker appears, we convert the disabled buttons to greyed out clickable buttons
        this.ConvertDatesOnPopup(customDatePicker);

        //After datepicker appears, we start to listen to the changes to that datepicker
        const parentElement = customDatePicker.getElementsByClassName("v-date-picker-table--date")[0];
        if (parentElement) {
          const menuContentObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
              if (mutation.type === "attributes" && mutation.attributeName === "class") {
                const target = mutation.target as HTMLElement;

                //Handle when date is selected and unselected, responding to the individual date button changes
                this.MakeButtonDisabled(target);

                //Handle when month is changed, responding to the entire month page changes
                this.ConvertDatesOnPopup(target);
              }
            });
          });

          menuContentObserver.observe(parentElement, {
            attributes: true,
            attributeFilter: ["class"],
            subtree: true
          });
        }
      }
    }
  }
}
